import { rgba } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { Page, Percent } from '~/components';
import { colors, weights } from '~/styles';

export const DashboardGrid = styled(Page.Widgets)`
  margin-top: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 32rem), 1fr));
  grid-auto-rows: auto;
  gap: 1rem;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  border: 1px solid ${colors.grey10};
  border-radius: 0.875rem;
  padding: 1.5rem 1.625rem;
  box-shadow: 0 0.0625rem 0.1875rem ${rgba(colors.black, 0.04)};
`;

export const Eyebrow = styled.span`
  font-size: 0.75rem;
  font-weight: ${weights.bold};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.grey40};
`;

export const BigValue = styled.div`
  margin-top: ${({ $flush }) => ($flush ? '0' : '1rem')};
  font-size: 2.25rem;
  line-height: 1;
  font-weight: ${weights.black};
  letter-spacing: -0.02em;
  color: ${colors.black};
  font-variant-numeric: tabular-nums;
`;

export const ValueRow = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: baseline;
  gap: 0.375rem;
`;

export const Unit = styled.span`
  font-size: 0.9375rem;
  font-weight: ${weights.bold};
  color: ${colors.grey40};
`;

const clampShare = (part, whole) => (whole > 0 ? Math.max(0, Math.min(100, (part / whole) * 100)) : 0);
export const shareLabel = (part, whole) => `${clampShare(part, whole).toFixed(1)}%`;

export const Legend = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5625rem;
  padding: 0.25rem 0;
`;

export const LegendLabel = styled.span`
  flex: 1;
  font-size: 0.8125rem;
  font-weight: ${weights.medium};
  color: ${colors.grey55};
`;

export const LegendValue = styled.span`
  font-size: 0.8125rem;
  font-weight: ${weights.bold};
  color: ${colors.black};
  font-variant-numeric: tabular-nums;
`;

export const LegendShare = styled.span`
  min-width: 2.375rem;
  text-align: right;
  font-size: 0.75rem;
  font-weight: ${weights.bold};
  color: ${colors.grey40};
  font-variant-numeric: tabular-nums;
`;

export const Divider = styled.div`
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid ${colors.grey10};
`;

export const ProfitHead = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const Pill = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0.3125rem;
  padding: 0.25rem 0.625rem;
  border-radius: 999px;
  white-space: nowrap;
  background: ${colors.grey10};
  color: ${colors.grey75};
`;

const PillPct = styled.span`
  font-size: 0.8125rem;
  font-weight: ${weights.bold};
  font-variant-numeric: tabular-nums;
`;

const PillWord = styled.span`
  font-size: 0.6875rem;
  font-weight: ${weights.medium};
`;

export function MarginPill({ value }) {
  return (
    <Pill>
      <PillPct>
        <Percent value={value} />
      </PillPct>
      <PillWord>margin</PillWord>
    </Pill>
  );
}
